import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, getInlineLoader } from "../Helpers";
import { STR_AVAILABLE_QUANTITY, STR_BUSINESS_NAME, STR_BUSINESS_TYPE, STR_CLIENT_LEVEL, STR_COMPANY, STR_CONTACT_US, STR_CUSTOMER, STR_DESCRIPTON, STR_EMAIL_ADDRESS, STR_GET_FREE_TRIAL, STR_INVALID_BUSINESS_NAME, STR_INVALID_NAME, STR_INVALID_NAME_2, STR_INVALID_PHONE_2, STR_INVALID_TITLE, STR_INVALID_UNIT, STR_INVALID_UNIT_PRICE, STR_LEAD, STR_NAME, STR_OPTIONAL, STR_PHONE_NUMBER, STR_PHYSICAL_ADDRESS, STR_POBOX, STR_PRODUCT_CODE, STR_REGISTER_BUSINESS, STR_REGISTER_CLIENT, STR_REGISTER_STOCK_ITEM, STR_REGISTER_VENDOR, STR_SOLE_PROPRIETOR, STR_SUBMIT, STR_SUCCESS, STR_TIN, STR_UNIT, STR_UNIT_PRICE, STR_VRN, STR_WEBSITE_URL, STR_WHATSAPP_NUMBER, STR_WITH_COUNTRY_CODE } from "../Strings";
import MobileInterface from "../MobileInterface";

import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { MdCall, MdEmail } from "react-icons/md";
import NapaAddressPicker from "../ones/NapaAddressPicker";


export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [unit, setUnit] = useState('');
  const [unitPrice, setUnitPrice] = useState(0);
  const [availableQuantity, setAvailableQuantity] = useState(1);
  const [code, setCode] = useState('');

  async function init() {
    //run initializations here
    setReady(false);
    //..
    setReady(true);
  }

  function resetForm() {
    setTitle('');
    setDescription('');
    setUnit('');
    setUnitPrice(0);
    setAvailableQuantity(1);
    setCode('')
  }

  async function submit() {
    if(title && title.trim().length > 0) {
      if(unit && unit.trim().length > 0) {
        if(!isNaN(unitPrice) && Number(unitPrice) > 0) {
          setLoading(true);
          await callApi(
            'register-stock-item',
            {
              title,
              description,
              unit,
              unitPrice,
              availableQuantity,
              code,
              businessUuid: appContext?.currentBusiness?.businessUuid,
            }
          ).then(response => {
            if(response.status === 1) {
              appContext.tellMessage(STR_SUCCESS[appContext.language]);
              resetForm();
              appContext.getAllStockItems();
              appContext.navBack();
            } else {
              appContext.tellError(response.msg);
            }
          })
          setLoading(false);
        } else {
          appContext.tellError(STR_INVALID_UNIT_PRICE[appContext.language]);
        }
      } else {
        appContext.tellError(STR_INVALID_UNIT[appContext.language]);
      }
    } else {
      appContext.tellError(STR_INVALID_TITLE[appContext.language]);
    }
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);

    return () => {
      appContext.setShowOverlayLoader(false);
    }
  }, [ loading ])

  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          <div className="row">

            <div className="col-md-12">
              <h6 className="main-section-title">
                {STR_REGISTER_STOCK_ITEM[appContext.language]}
              </h6>
            </div>

            
            <div className="col-md-12 mt-3 mb-3">
              <label className="form-label">{STR_NAME[appContext.language]}</label>
              <input
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="col-md-12 mt-3 mb-3">
              <label className="form-label">{STR_DESCRIPTON[appContext.language]}</label>
              <textarea
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <div className="form-text">{STR_OPTIONAL[appContext.language]}</div>
            </div>  

            <div className="col-md-6 mt-3 mb-3">
              <label className="form-label">{STR_UNIT[appContext.language]}</label>
              <input
                className="form-control"
                value={unit}
                onChange={(e) => setUnit(e.target.value)}
              />
            </div>    

            <div className="col-md-6 mt-3 mb-3">
              <label className="form-label">{STR_UNIT_PRICE[appContext.language]}</label>
              <input
                className="form-control"
                value={unitPrice}
                onChange={(e) => setUnitPrice(e.target.value)}
              />
            </div>

            <div className="col-md-6 mt-3 mb-3">
              <label className="form-label">{STR_AVAILABLE_QUANTITY[appContext.language]}</label>
              <input
                className="form-control"
                value={availableQuantity}
                onChange={(e) => setAvailableQuantity(e.target.value)}
              />
            </div>    

            <div className="col-md-6 mt-3 mb-3">
              <label className="form-label">{STR_PRODUCT_CODE[appContext.language]}</label>
              <input
                className="form-control"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
              <div className="form-text">{STR_OPTIONAL[appContext.language]}</div>
            </div>

            <div className="col-md-12 mt-3 mb-5">
              <button
                className="btn btn-block btn-padded btn-rounded btn-secondary"
                onClick={submit}
              >
                {STR_SUBMIT[appContext.language]}
              </button>
            </div>

          </div>

        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}